export function getDefaultFontFamily(): string {
    return "Delagothicone Regular";
}
